/* global orderConfData */
$(document).ready(() => {
  const $form = $(document).find('[data-cms-form]');
  if ($form.length && Object.keys(orderConfData).length) {
    const fieldIds = ['id_auftrag', 'id_kunde', 'id_kunden_nr', 'id_anrede', 'id_vorname', 'id_name', 'id_mail'];
    const $fields = $form.find(':input');
    const populateField = ($field) => {
      $field.closest('label').hide();
      $field.val(orderConfData[$field.attr('id')]);
    };
    $fields.each((index, field) => {
      const $field = $(field);
      if (fieldIds.includes($field.attr('id'))) {
        populateField($field);
      }
    });
  }
});
